export const TeamData = {
  file: "",
  prevProfile: "",
  dirname: "addTeam",
  profile: "",
  ID: 0,
  isEmialChange: 0,
  FirstName: "",
  Email: "",
  PassWord: "",
  ConformPassword: "",
  phoneNumber: "",
  ContactNumber: "",
  RoleID: 0,
  CalendorColorID: 0,
  Address1: "",
  Address2: "",
  Country: "",
  State: "",
  City: "",
  ZipCode: "",
  designation: "",
  EmergencyContact: [],
  Serviceandcommision: [
    {
      category: "",
      name: "",
      price: "",
      duration: "",
      Ischecked: true,
      serviceId: 0,
      ID: 0,
      homeserviceprice: ""
    },
  ],
};
